<template>
	<div class="modal-wrapper" :class="{ 'modal-show': show }">
		<div class="modal"  v-if="show"  v-on-clickaway="hide">
			<span class="modal-close"  @click.prevent="show = false"><img src="/img/home-v2/navbar-icons/close.svg"></span>
			<div>
				<div class="sub-progress" >
					<div>
						<div class="sub-progress-text">50% complete! Please fill out this form to get instant access.</div>
						<div class="sub-progress-bar">
							<svg style="max-width: 100%" width="391" height="18" viewBox="0 0 391 18" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M381.916 18H9.08397C4.15267 18 0 14.0143 0 9C0 4.11429 4.15267 0 9.08397 0H381.916C386.847 0 391 4.11429 391 9C391 14.0143 386.977 18 381.916 18Z" fill="#F3F0FF"/>
								<path d="M177.766 18H8.991C3.9817 18 -4.57764e-05 14.0143 -4.57764e-05 9C-4.57764e-05 4.11429 4.11015 0 8.991 0H177.766V18Z" fill="url(#paint0_linear)"/>
								<path opacity="0.1" d="M16.4409 18H9.24805L16.4409 0H23.7622L16.4409 18Z" fill="white"/>
								<path opacity="0.1" d="M32.1113 18H24.79L32.1113 0H39.4326L32.1113 18Z" fill="white"/>
								<path opacity="0.1" d="M47.7812 18H40.46L47.7812 0H55.1025L47.7812 18Z" fill="white"/>
								<path opacity="0.1" d="M63.3227 18H56.1299L63.3227 0H70.644L63.3227 18Z" fill="white"/>
								<path opacity="0.1" d="M78.9931 18H71.6719L78.9931 0H86.3144L78.9931 18Z" fill="white"/>
								<path opacity="0.1" d="M94.6631 18H87.3418L94.6631 0H101.984L94.6631 18Z" fill="white"/>
								<path opacity="0.1" d="M110.205 18H103.012L110.205 0H117.526L110.205 18Z" fill="white"/>
								<path opacity="0.1" d="M125.875 18H118.554L125.875 0H133.196L125.875 18Z" fill="white"/>
								<path opacity="0.1" d="M141.545 18H134.224L141.545 0H148.866L141.545 18Z" fill="white"/>
								<path opacity="0.1" d="M157.086 18H149.894L157.086 0H164.408L157.086 18Z" fill="white"/>
								<path opacity="0.1" d="M172.757 18H165.436L172.757 0H180.078L172.757 18Z" fill="white"/>
								<defs>
								<linearGradient id="paint0_linear" x1="88.8828" y1="0" x2="88.8828" y2="18" gradientUnits="userSpaceOnUse">
								<stop stop-color="#BD69FF"/>
								<stop offset="1" stop-color="#8A69FF"/>
								</linearGradient>
								</defs>
							</svg>
						</div>
					</div>
				</div>
				<div class="form-wrapper">
					<h1>Enter Your Details</h1>
					<!-- <p><span v-text="invitationNumber"></span> People Already Joined</p> -->
					<form  @submit="checkForm" >
						<div class="input-wrapper mb-3">
							<label for="name-sub">Name *</label>
							<input type="text" v-model="name" required placeholder="Enter your name" id="name-sub">
							<!-- <span class="form-icon-wrapper">
								<img src="/landing/img/user.png">
							</span> -->
							<div class="input-error" v-if="errorName" v-text="errorName"></div>
						</div>
						<div class="input-wrapper mb-3">
							<label for="email-sub">Email *</label>
							<input type="email" v-model="email" required placeholder="Enter your email" class="subscribe-email" id="email-sub">
							<!-- <span class="form-icon-wrapper" style="top: 11px;">
								<img src="/landing/img/mail.png">
							</span> -->
							<div class="input-error" v-if="errorName" v-text="errorEmail"></div>
						</div>
						<div class="input-wrapper">
							<label>Select Role</label>
							<div id="roleDropdown" class="dropdown">
								<button type="button" id="roleDropdownButton" data-flip="false" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
									{{role}}
								</button>
								<div class="dropdown-menu" aria-labelledby="roleDropdownButton">
									<div v-for="(dropdownRole, index) in roles"
										:key="index"
										class="dropdown-item"
										@click="role = dropdownRole">
										{{dropdownRole}}
									</div>
								</div>
							</div>
							<!-- <label for="roles">Select role</label>
							<select name="roles" id="roles">
								<option value="Chief Product Officer">Chief Product Officer</option>
								<option value="Product Manager">Product Manager</option>
								<option value="CTO">CTO</option>
								<option value="Developer">Developer</option>
								<option value="Project Manager">Project Manager</option>
								<option value="Other">Other...</option>
							</select> -->
						</div>
						<br>
						<button type="submit" class="cta-btn-v2 sub-submit m-auto">Download eBook</button>
						<p>
							We value your privacy, and we'll never misuse private information that you entrust us with.
						</p>
					</form>
				</div>
			</div>
			<!-- <div v-else>
				<h1>Share What You’ve Found</h1>
				<p>Infinity is a flexible all-in-one platform where you can organize your workflow, collaborate with your team members and store data.</p>
				<div class="modal-social wishlist-social">
					<div class="social" @click.stop="socialShare('https://www.facebook.com/sharer/sharer.php?u=https://startinfinity.com')">
						<img src="/landing/img/raw.png">
						<span>Share</span>
					</div>

					<div class="social" @click.stop="socialShare('https://twitter.com/intent/tweet?text=Check out Infinity - a flexible project management tool I just signed up for %23productivity https://startinfinity.com via @startinfinity')">
						<img src="/landing/img/twitter.png">
						<span>Tweet</span>
					</div>

					<div class="social" @click.stop='socialShare(mail)'>
						<img src="/landing/img/email.png">
						<span>Email</span>
					</div>

				</div>

				<input class="copy-paste" @click.stop.prevent="copyToClipboard" type="text" value="https://startinfinity.com?referral=BybVB7tYM">
				<p class="copied" v-if="copied">Link Copied to Clipboard</p>

			</div> -->
		</div>
	</div>
</template>
<style type="text/css" scoped lang="less">
	#roleDropdown {
        width: 100%;
        #roleDropdownButton {
            // appearance: none;
            width: 100%;
            height: 50px;
            border: 1px solid #C9C9C9;
            background-color: #fff;
            border-radius: 6px;
            color: #120C32;
            padding: 15px 18px;
            font-size: 16px;
            background-image: url('/img/pricing/dropdown-arrow-down.svg');
            background-repeat: no-repeat;
            background-size: 15px 9px;
            background-position: 95% 50%;
            text-align: left;
            display: flex;
            align-items: center;
            &:focus, &:active {
                border: 1px solid #BFB6FF;
                outline: none;
            }
			@media (max-width: 768px) {
				height: 40px;
			}
        }
        .dropdown-menu {
            width: 100%;
            background: #FFFFFF;
            box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.25);
            border-radius: 6px;
            padding: 7px;
			@media (max-height: 750px) {
				height: 170px;
				overflow-y: scroll;
			}
			&::-webkit-scrollbar {
				border-radius: 10px;
				width: 8px;
				background-color: #F5F5F5;
			}
			&::-webkit-scrollbar-thumb {
				border-radius: 10px;
				background-color: #62647b36;
			}
            .dropdown-item {
                cursor: pointer;
                border-radius: 6px;
                font-size: 16px;
                &:hover {
                    background-color: #F6F4FF;
                }
            }
            .dropdown-item.active {
                background-color: transparent;
                color: #5946CF;
                background-image: url('/img/pricing/ic-check.svg');
                background-repeat: no-repeat;
                background-size: 15px 9px;
                background-position: 95% 50%;
                text-align: left;
            }
        }
    }
	.modal-wrapper{
		position: fixed;
		top:0;
		left:0;
		height:100%;
		width: 100%;
		background:rgba(0,0,0,0.8);
		z-index:101;
		display:none;
		align-items:center;
		justify-content: center;

	}
	.modal-show{
		display:flex;
	}

	.modal{
		overflow: visible;
		background: #FAFBFC;
		height:auto;
		width:470px;
		background-size: 100% 100%;
		text-align:center;
		position:relative;
		display:inline !important;
		z-index:4;
		border-radius:20px;
	}
	@media (max-width: 650px) {
		.modal{
			width:90%;
		}
	}
	.form-wrapper{
		padding-left:40px;
		padding-right:40px;
		padding-bottom:45px;
	}
	@media (max-width: 650px) {
		.form-wrapper{
			padding-left:20px;
			padding-right:20px;
			padding-bottom:25px;
		}
	}
	.modal h1{
		text-align: center;
		margin-top:20px;
		font-weight: 500;
		font-size: 25px !important;
		line-height: 34px;
		color: #120C32;
		font-family: 'Avenir Next Medium';
	}
	.modal p{
		font-size: 18px;
		line-height: 21px;
		text-align: center;
		color: #120C32;
		margin:0 auto;
		margin-bottom:50px;
		max-width:500px;
		margin-bottom: 0 !important;
	}

	.modal .sub-submit{
		border: none;
		margin-bottom:30px !important;
		@media (max-width: 768px) {
			margin-bottom: 20px !important;
		}
	}
	.modal p{
		font-weight: 500;
		font-size: 14px;
		line-height: 19px;
		text-align: center;

		color: rgba(18, 12, 50, 0.56);
	}
	.modal label{
		display: block;
		font-weight: 500;
		font-size: 18px;
		line-height: 25px;
		color: #120C32;
		text-align: left;
	}
	.modal input{
		/* border: 1px solid #FFFFFF; */
		background: #FFFFFF;
		border: 1px solid #DFDFDF;
		box-sizing: border-box;
		border-radius: 6px;
		font-size: 18px;
		line-height: 25px;
		width:100%;
		height: 50px;
		padding-left:18px;
		&:active, &:focus {
			border: 1px solid #BFB6FF;
		}
		@media (max-width: 768px) {
			height: 40px;
		}
	}
	.modal .sub-progress{
		height:100px;
		width:100%;
		background:white;
		padding: 25px 40px;
		border-radius: 20px 20px 0 0;
	}
	@media (max-width: 650px) {
		.modal .sub-progress{
			padding: 25px 20px;
		}
	}
	.modal .sub-progress-text{
		font-size: 14px;
		line-height: 19px;
		text-align: center;
		color: #000000;
		margin-bottom:11px;
	}
	.modal ::-webkit-input-placeholder {
		font-weight: 500;
		font-size: 18px;
		line-height: 25px;
		color: #989898;
	}
	.modal ::-moz-placeholder {
		font-weight: 500;
		font-size: 18px;
		line-height: 25px;
		color: #989898;
	}
	.modal :-ms-input-placeholder {
		font-weight: 500;
		font-size: 18px;
		line-height: 25px;
		color: #989898;
	}
	.modal :-moz-placeholder {
		font-weight: 500;
		font-size: 18px;
		line-height: 25px;
		color: #989898;
	}

	.modal-close{
		position: absolute;
		right: 6px;
		top: 6px;
		cursor:pointer;
		z-index: 99;
		img {
			width: 20px;
		}
	}
</style>
<script>
import { mixin as clickaway } from 'vue-clickaway';
import axios from 'axios';

export default {
//    mixins: [ VueClickaway.mixin ],
    mixins: [ clickaway ],
    data() {
        return {
            errorName: null,
            errorEmail: null,
            name: null,
            email: null,

            show: false,
            submited: false,
            role: 'Role',
            roles: [
                'Chief Product Officer', 'Product Manager', 'CTO', 'Developer', 'Designer', 'Project Manager', 'Other'
            ]
        };
    },
    methods:{

        checkForm: function (e) {

            e.preventDefault();

            if (this.name && this.age) {
                return true;
            }

            this.errorName = null;
            this.errorEmail = null;

            if (!this.name) {
                this.errorName = 'Name required.';
            }
            if (this.name && this.name.length < 3) {
                this.errorName = 'Name must be at least 2 character.';
            }

            if (!this.email) {
                this.errorEmail = 'Email required.';
            }


            if(this.errorName == null && this.errorEmail == null){
                window.Intercom('boot', {
                    app_id: 'ujmidnoy',
                    email: this.email,
                    name: this.name,
                    opt_pm_ebook: true, // custom attribute ( property )
                    opt_pm_ebook_role: this.role,
                    user_id: this.email ,
                    created_at:  Math.round((new Date()).getTime() / 1000),
                });

                // push tag to google tag manager
                dataLayer.push({'event': 'OPT_pm_ebook'});

                axios.put('/api/analytics', {
                    'name': 'OPT_pm_ebook',
                });

                // add to cookie
                this.$cookies.set('ebook_submited', true ,60 * 60 * 24 * 30* 12 );
                this.$cookies.set('email', this.email ,60 * 60 * 24 * 30* 12 );
                this.$cookies.set('name', this.name ,60 * 60 * 24 * 30* 12 );
                this.submited = true;
                window.open('/downloads/Product-Management-eBook.pdf', '_blank');
                this.show = false;
            }
        },
        addCommas(number){
            number += '';
            let x = number.split('.');
            let x1 = x[0];
            let x2 = x.length > 1 ? '.' + x[1] : '';
            let rgx = /(\d+)(\d{3})/;
            while (rgx.test(x1)) {
                x1 = x1.replace(rgx, '$1' + ',' + '$2');
            }
            return x1 + x2;
        },
        copyToClipboard(){
            const el = document.createElement('textarea');
            el.value = 'https://startinfinity.com?referral=BybVB7tYM';
            el.setAttribute('readonly', '');
            el.style.position = 'absolute';
            el.style.left = '-9999px';
            document.body.appendChild(el);
            el.select();
            document.execCommand('copy');
            document.body.removeChild(el);
            this.copied = true;
        },
        hide () {
            this.show = false;
        },
    },
    mounted() {
        this.submited =  this.$cookies.isKey('ebook_submited');

        this.$eventHub.$on('showModal', function () {
            if(this.submited) {
                // this.show = true;
                window.open('/downloads/Product-Management-eBook.pdf', '_blank');
            } else {
                this.show = true;
            }
        }.bind(this));

    },
};
</script>


// WEBPACK FOOTER //
// resources/js/frontend/components/EbookSubscribe.vue